import styled from 'styled-components';

const AccordionWrapper = styled.div`
  margin: ${({ margin }) => margin || '0'};

  & .brand-list:focus {
    outline-style: none;
  }
`;

export default AccordionWrapper;
